import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer } from '@mui/material';
import DynamicMainMenuList from './DynamicMainMenuList';

const buttonStyling = {};

export default function HeaderMenuButton() {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
        if (open) {
            setAnchorEl(null);
        } else {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = () => setAnchorEl(null);

    return (
        <div className="menu-button-container">
            <div className="menu-button">
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                >
                    {open ? (
                        <CloseIcon style={{ fontSize: '3rem', fontWeight: 'bold' }} />
                    ) : (
                        <MenuIcon style={{ fontSize: '3rem', fontWeight: 'bold' }} />
                    )}
                </IconButton>
                <Drawer
                    anchor="right"
                    id="long-menu"
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        style: {
                            top: 95,
                            height: '600px',
                            width: '100%',
                            maxWidth: '100%',
                            left: '0px',
                            right: '0px',
                            position: 'fixed',
                        },
                        elevation: 0,
                    }}
                    BackdropProps={{
                        style: { backgroundColor: 'transparent' },
                    }}
                >
                    <ul className="nav-button-list">
                        <DynamicMainMenuList
                            buttonStyling={buttonStyling}
                            isNavSubMenu
                            handleNavClose={handleClose}
                            renderAfter={() => (
                                <hr
                                    style={{
                                        width: '100%',
                                        fontWeight: 700,
                                        color: '#CACBCD',
                                    }}
                                />
                            )}
                        />
                    </ul>
                </Drawer>
            </div>
        </div>
    );
}
